import Moment from "moment";


export default function formatDate(date?:Moment | null, format:string|null=null):string {

    // date is a moment object here

    if (!date) return ''

    if (!format) {
        format = gd.user.formatSettings.date
    }

    switch (format) {

        case 'MMM D':
            format = (date.year()===Moment().year()) ? 'MMM D' : 'MMM D, YYYY'
            break

        case 'D MMM':
            format = (date.year()===Moment().year()) ? 'D MMM' : 'D MMM, YYYY'
            break

        case 'DD MM YY':
            format = 'DD.MM.YY'
            break

        default:
            break
    }


    // @ts-ignore
    return date.format(format)

}